import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { api_url } from '../../../js_assets/ConfigApp';
import { GetApi, PostApi } from '../../../js_assets/Network';

import CircularProgress from '@material-ui/core/CircularProgress';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import AppAdminContainer from '../AppAdminContainer'
import Divider from '@material-ui/core/Divider';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import DialogContent from '@material-ui/core/DialogContent';

import Dialog from '@material-ui/core/Dialog';

import Hammer from 'react-hammerjs';

const styles = theme => ({
    root: {
        flexGrow: 1,
        marginTop: 8,
        margin: 12

    },
    divider: {
        width: '100%',
    },
    ButtonRemove: {
        backgroundColor: 'red',
        color: 'white',
        '&:hover': {
            background: 'red'
        },
        padding: '5px'
    },
    ButtonGuide: {
        backgroundColor: '#74cbc4',
        color: 'white',
        '&:hover': {
            background: '#74cbc4'
        },
        margin: theme.spacing.unit,
        padding: '2px'
    },
    tab: {
        flexGrow: 1,
        marginTop: -5,
        backgroundColor: '#f7faea',
        fontFamily: [
            'DIN-NEXT™-ARABIC-BOLD',
        ].join(','),
    },
    tab_button: {
        fontSize: 18,
        fontFamily: [
            'DIN-NEXT™-ARABIC-BOLD',
        ].join(','),
    },
    iocns: {
        fontSize: 18
    }


});

class AdminStore extends Component {

    constructor(props) {
        super(props);
        this.state = {
            Store_Data: [],
            Admin_Info: JSON.parse(localStorage.getItem("Admin_Info")),
            loading_state_iocn: true,
            delivery_Price: [],
            store_Available: null,
            store_Available_Id: null,
            Dialog_store_Available: false
        };
    }

    componentDidMount() {

        const { Admin_Info } = this.state;



        //console.log(Admin_Info);
        let GetStores = GetApi(`/api/store/GetStores/${Admin_Info.admin_Id}`, Admin_Info.jwT_Token_Admin);

        GetStores.then((result) => this.setState({ Store_Data: result, loading_state_iocn: false }))
    }




    get_delivery_Price = (id) => {

        const { delivery_Price } = this.state

        let list_price = [];

        let result = "";

        list_price = delivery_Price;

        list_price.map(item => {

            if (item.delivery_Price_ID == id) {


                result = item.delivery_Price_Amount;
            }


        })



        return result;
    }




    redirectToUrl = (Component) => {

        window.location.href = window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + Component
    }


    handle_Dialog_store_Available = (guid) => {


        this.setState({ store_Available_Id: guid.store_Id, store_Available: guid.store_Available, Dialog_store_Available: true })

    }


    handle_close_store_Available = () => {


        this.setState({ store_Available_Id: null, store_Available: null, Dialog_store_Available: false })

    }

    onChange_store_Available = event => {

        const { Admin_Info, store_Available_Id } = this.state;
        let Trainer_Info = JSON.parse(localStorage.getItem("Trainer_Info"))



        //console.log(event.target.checked)

        if (event.target.checked === true) {


            let EnableStore = GetApi(`/api/store/EnableStore/${store_Available_Id}/${Admin_Info.admin_Id}`, Admin_Info.jwT_Token_Admin);

            EnableStore.then(() => {

                this.setState({ store_Available: true });

            })

        }
        else {
            let DisableStore = GetApi(`/api/store/DisableStore/${store_Available_Id}/${Admin_Info.admin_Id}`, Admin_Info.jwT_Token_Admin);

            DisableStore.then(() => {

                this.setState({ store_Available: false });

            })

        }




    }



    render() {
        const { classes } = this.props;
        const { Store_Data, loading_state_iocn } = this.state;


        //console.log(Store_Data);

        return (

            <AppAdminContainer Title={"المتاجر"}>



                <Grid justify="center" alignItems="center" container spacing={8}>

                    <Grid item xs={6}>
                        <Hammer onTap={() => this.redirectToUrl('/Admin/FormAdminStore?store_Id=New')}>
                            <div>
                                <button size="small" variant="contained" className={classes.ButtonGuide}   >
                                    <label> اضافة متجر جديد</label>
                                </button>
                            </div>
                        </Hammer>
                    </Grid>
                    <Grid item xs={6}>

                        <button size="small" variant="contained" onClick={() => this.redirectToUrl('/Admin/AdminStoreSaleReport?store_Id=all')} className={classes.ButtonGuide}   >
                            <label> التقرير المالي للكل</label>
                        </button>

                    </Grid>

                </Grid>




                <Divider className={classes.divider} />


                {loading_state_iocn ? <div className="centerloadingicon" ><CircularProgress /></div> : Store_Data.length == 0 ? null :

                    Store_Data.map((guid) => {

                        var date_expiry = new Date(Date.parse(guid.store_Create_Date))

                        var datetime_expiry = date_expiry.toISOString().split('T')[0];

                        var delivery_Price_Amount = guid.store_Delivery_Price !== 0 ? guid.store_Delivery_Price : "مجاني"


                        return (
                            <div>

                                <div className="w3-cell-row">
                                    <div className="w3-cell">
                                        <img className="w3-circle" src={`${api_url}/Content/Store_Image/${guid.store_Image}`} ></img>
                                    </div>
                                    <div className="w3-cell w3-container" >
                                        <h4>{guid.store_Name}</h4>
                                        <span > رقم المتجر</span>  : <span >  {guid.store_Id} </span><br></br>
                                        <span > حالة المتجر</span>  : <span >  {guid.store_Available === true ? 'متاح' : 'غير متاح'} </span><br></br>
                                        <span > رقم الجوال</span>  : <span >  {guid.store_PhoneNumber} </span><br></br>
                                        <span >  البريد الالكتروني </span> :  <span >{guid.store_Email}  </span> <br></br>
                                        <span>   حد التسوق </span> :  <span >{guid.store_Limit_Order}  </span> <br></br>
                                        <span>  سعر التوصيل  </span> :  <span > {delivery_Price_Amount}  </span> <br></br>
                                        <span>   وصف المتجر </span> :  <span >{guid.store_Describe}  </span> <br></br>
                                        <hr />
                                        <span>  تاريخ التفعيل </span> :  <span >{datetime_expiry}  </span> <br></br>



                                        <button size="small" variant="contained" className={classes.ButtonGuide} onClick={() => this.redirectToUrl(`/Admin/FormAdminStore?store_Id=${guid.store_Id}`)}   >
                                            <span className="span12px"> تحديث</span>
                                        </button>

                                        <button size="small" variant="contained" className={classes.ButtonGuide} onClick={() => this.redirectToUrl(`/Admin/AdminStoreSaleReport?store_Id=${guid.store_Id}`)}   >
                                            <span className="span12px"> تقرير المالي</span>
                                        </button>

                                        <button size="small" variant="contained" className={classes.ButtonGuide} onClick={() => this.handle_Dialog_store_Available(guid)}   >
                                            <span className="span12px">  توقيف المتجر</span>
                                        </button>

                                    </div>



                                </div>

                                <hr></hr>

                            </div>

                        )



                    })

                }


                <Dialog
                    fullWidth={'sm'}
                    maxWidth={"sm"}
                    open={this.state.Dialog_store_Available}
                    onClose={this.handle_close_store_Available}
                    aria-labelledby="max-width-dialog-title"
                >
                    <DialogContent>
                        <div>
                            <h3> اغلاق المتجر مؤقت </h3>
                            <FormControlLabel

                                control={
                                    <Switch
                                        checked={this.state.store_Available}
                                        onChange={this.onChange_store_Available}
                                        value="fullWidth"
                                    />
                                }
                                label="للتفعيل او الايقاف"
                            />

                        </div>
                    </DialogContent>
                </Dialog>

            </AppAdminContainer>



        )
    }


}
AdminStore.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AdminStore);
